window.MONTH_YEAR_FORMAT = 'MMM YYYY';
window.DATE_FORMAT = 'DD MMM, YYYY';

const DEFAULT_CHECKBOX_MULTISELECT_MAX_HEIGHT = 260;

window.append_errors_inside_modal = (errors_list, header_message, element) => {
  $(element).removeClass("d-none");
  $(element).html(header_message);
  for (let error of Array.from(errors_list)) {
    const error_message = `<div class='text-danger px-5'> \
                              <ul>
                                <li> ${
                                  error.charAt(0).toUpperCase() + error.slice(1)
                                } </li> \
                              </ul>\
                           </div>`;
    $(element).append(error_message);
  }
};

window.append_success_message = (success_list, header_message, element) => {
  const success_message =`<div class='alert alert-success w-100'>\
                          <h6> ${header_message} </h6>` +
                          success_list +
                          "</div>";
  element.removeClass("d-none");
  element.html(success_message);
};

window.adjust_comment_position = (mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type == 'childList') {
      let id = $('#comment-box-modal').data('id')
      let addedNodes = mutation.addedNodes
      addedNodes.forEach((node) => {
        if ($(node).hasClass(`comment-${id}`)) {
          $(node).addClass('justify-content-end')
          $(node).find('.comment-section').removeClass('bg-light-grey')
          $(node).find('.comment-section').addClass('bg-primary text-white')
        }
      })
      $('.comment-message').trigger('focus');
    }
  })
};

$(document).on("mouseenter", ".nav-dropdown-item", (e) => {
  $(e.target).removeClass("text-light");
});

$(document).on("mouseleave", ".nav-dropdown-item", (e) => {
  $(e.target).addClass("text-light");
});

window.apply_custom_date_input = () => {
  $(".custom-date-input").datetimepicker({
    format: window.DATE_FORMAT,
    icons: {
      previous: "fas fa-chevron-left",
      next: "fas fa-chevron-right",
    },
  });
};

window.initialize_checkbox_multiselects = (selector = '.checkbox-multiselect') => {
  $(selector).each(function () {
    let dropdown = $(this);
    if (dropdown.data('multiselect')) return;
    const emptyText = dropdown.data('empty-text');
    const nonSelectedText = dropdown.data('non-selected-text') || 'None selected';
    const configuredMaxHeight = dropdown.data('max-height');
    const maxHeight = configuredMaxHeight === undefined
      ? DEFAULT_CHECKBOX_MULTISELECT_MAX_HEIGHT
      : configuredMaxHeight;

    dropdown.multiselect({
      allSelectedText: 'All',
      buttonWidth: '100%',
      buttonTextAlignment: 'left',
      disableIfEmpty: Boolean(emptyText),
      disabledText: emptyText || nonSelectedText,
      enableCaseInsensitiveFiltering: dropdown.data('enable-filtering') === true,
      includeSelectAllOption: dropdown.data('include-select-all-option') !== false,
      maxHeight: maxHeight,
      nonSelectedText: nonSelectedText,
      numberDisplayed: 1,
      onChange: (option, checked) => {
        if (!checked || !dropdown.data('exclusive-all')) return;

        const selectedValue = option.val();
        const selectedValues = dropdown.val() || [];
        if (selectedValue === 'all') {
          dropdown.val(['all']);
        } else if (selectedValues.includes('all')) {
          dropdown.val(selectedValues.filter((value) => value !== 'all'));
        }
        dropdown.multiselect('refresh');
      },
      onFiltering: (filterInput) => {
        const container = $(filterInput).closest('.multiselect-container');
        const hasMatches = container
          .find('.multiselect-option:not(.disabled):not(.multiselect-filter-hidden)').length > 0;

        container.find('.multiselect-all').toggle(hasMatches);
      },
      selectAllText: 'All',
      widthSynchronizationMode: 'ifPopupIsSmaller'
    });

    dropdown.on('change.checkboxMultiselect', () => dropdown.multiselect('refresh'));
  });
};

document.addEventListener('DOMContentLoaded', () => {
  $('.select-option').select2({ theme: 'bootstrap4' });
  initialize_checkbox_multiselects();
  apply_custom_date_input();
  $('#new-employees-table').DataTable({
    scrollY: '350px',
    pageLength: 10,
    createdRow: function( row, data, dataIndex, columns ) {
      $(row).addClass('employee-row cursor-pointer') ;
      $(columns[0]).addClass('pl-5');
    }
  });
  $('.scrollable-datatable').not('.dataTable').DataTable({
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10
  });
  $('.fixedheader-datatable').DataTable({
    fixedHeader: true
  });
  adjust_visible_datatables();
  let top_height = ($('.dt-scroll-head').length) ? $('.dt-scroll-head').offset().top : 0;
  $('#new-employees-table').closest('.dt-scroll-body').height(`calc(100vh - ${top_height + 0.52 * top_height}px)`);
  $('#new-employees-table').closest('.dt-scroll-body').addClass('dashboard-datatable');
  $('.scrollable-datatable').closest('.dt-scroll-body').addClass('scrollable-max-height')
  $('.dataTable').on('page.dt', () => { $('.dt-scroll-body').animate({ scrollTop: 0 }, 'fast') });
  $('.select_time_zone').select2({ theme: 'bootstrap4', width:'100%' })
  $('.btn-disabled').prop('disabled', true);
  fade_alert_container();
});

$(document).on('change', '.salary-chart-tooltip-mode', (e) => {
  if (!window.applySalaryChartTooltip) return;

  let toggle = $(e.currentTarget);
  let hover_total_selector = toggle.data('hover-total-selector');
  window.applySalaryChartTooltip(
    toggle.data('chart-id'),
    $(hover_total_selector).length > 0,
    `#${toggle.attr('id')}`,
    hover_total_selector
  );
});

window.append_avatar = (obj) => {
  data = $(obj.element).data();
  text = $(obj.element).text();
  if (data && data["img_src"]) {
    img_src = data["img_src"];
    template = $(`<div class='row p-0 ml-2 d-flex flex-nowrap'> \
                  <img class = "rounded-circle avatar-size-select-box" src = "${img_src}" "> \
                  <div class = "d-flex align-self-center ml-2 select-box-font-size"> ${text}</div></div>`);
    return template;
  }
};

window.select2_avatar_options = () => {
  const options = {
    templateSelection: function (data) {
      return data.id === "" ? "Please Select Employees" : append_avatar(data);
    },
    templateResult: append_avatar,
  };
  $(".select-employees").select2(options);
};

$(document).on('click', '.destination-page', (e) => {
  let parentElement = $(e.target.parentElement);
  let path = parentElement.attr('data') || parentElement.closest('.destination-page').attr('data');
  window.location = path
});

$(document).on('click', '.employee-profile-page', (e) => {
  e.stopPropagation();
  let path = $(e.target).attr('data');
  window.open(path, '_blank');
});

$(window).resize(() => adjust_visible_datatables())

var adjust_visible_datatables = () => {
  $.fn.dataTable
    .tables({ visible: true, api: true })
    .columns.adjust()
}

$(document).on('shown.bs.modal', (e) => {
  $('input[name="foreign_salary_payment_detail[amount]"]').trigger('focus')
  $('form :input:not([readonly]):visible:enabled:first', e.target).trigger('focus');
  $('.comment-message').trigger('focus');
});

$(document).on('keypress', '.bootstrap-toggle-wrapper', (e) => {
  if (e.key === ' ' || e.key === 'Spacebar') {
    e.preventDefault();
    let checkbox = $('input[type="checkbox"]:first', e.target);
    checkbox.bootstrapToggle('toggle');
  }
});

$(document).on('select2:open', () => {
  document.querySelector('.select2-search__field').focus();
});

$(document).on('shown.bs.modal', (e) => {
  $('body').css('overflow', 'hidden');
});

$(document).on('hidden.bs.modal', (e) => {
  $('body').css('overflow', 'auto');
});

show_alert_container = () => {
  $('.alert-container').css('display', 'block');
  fade_alert_container();
}

fade_alert_container = () => {
  $(".alert-container").fadeTo(5000, 1000).slideUp(1000, function() {
    $(".alert-container").slideUp(1000);
  });
}

$(document).on('click', '.disable-propagation', (e) => {
  e.stopPropagation();
});

const format_number_with_delimiter = (number) => number.toLocaleString('en-US')

$(document).on('click', '.mark-as-read', (e) => {
  let target_item = $(e.currentTarget)
  let notification_id = target_item.attr('data-notification-id')
  $.ajax({
    type: 'Put',
    url: `/notifications/${notification_id}`,
    success(response) {
      let marked_as_read_item = $(`.mark-as-read[data-notification-id=${response.notification_id}]`)
      marked_as_read_item.removeClass('bg-grey cursor-pointer mark-as-read')
      let notifications_count_element = $('.no-of-notifications')[0].innerHTML
      let no_of_notifications = parseInt(notifications_count_element.replace(/,/g, ''))
      if (no_of_notifications > 1) {
        $('.no-of-notifications')[0].innerHTML = format_number_with_delimiter(no_of_notifications - 1)
      } else {
        $('.no-of-notifications')[0].innerHTML = ''
        $('.mark-all-as-read').remove()
      }
    }
  })
})

$(document).on('click', '.mark-all-as-read', (e) => {
  $.ajax({
    type: 'Patch',
    url: '/notifications/mark_all_as_read',
    success(response) {
      $('.mark-as-read').removeClass('bg-grey cursor-pointer mark-as-read')
      $('.no-of-notifications')[0].innerHTML = ''
      $('.mark-all-as-read').remove()
      append_success_message_in_alert_container(response.message)
      $('html').scrollTop(0)
    }
  })
})

const get_notifications = (page_no) => {
  $.ajax({
    type: 'Get',
    url: '/notifications',
    data: { page_no: page_no },
    success(response) {
      $('.notification-spinner').remove()
      $('.notifications-dropdown').append(response.html)
    }
  })
}

$(document).on('click', '.fa-bell, #notification-dropdown-btn', (e) => {
  $('.notification-spinner').removeClass('d-none')
  get_notifications(1)
})

$(document).on('click', '.see-more', (e) => {
  $('.see-more').remove()
  $('.notification-spinner').removeClass('d-none')
  let page_no = $(e.currentTarget).attr('data-page-no')
  $(e.currentTarget).attr('data-page-no', `${page_no + 1}`)
  get_notifications(parseInt(page_no) + 1)
})

$(document).on('shown.bs.modal', (e) => {
  $(document).on('keyup', (e) => {
    if(e.key == 'Escape') { $('.modal').modal('hide') }
  })
})

$(document).on('shown.bs.modal hidden.bs.modal shown.bs.tab', () => adjust_visible_datatables());

$(document).on('input', '.amount_format', (e) => {
  current_target = $(e.currentTarget)
  current_target.on('keyup', (e) => {
    return (e.charCode == 8 || e.charCode == 0 || e.charCode == 13) ? null : e.charCode >= 48 && e.charCode <= 57 || e.charCode == 45
  });

  value = current_target.val().replaceAll(',', '')
  if (value == '-') {
    current_target.val(value)
    return;
  }
  isNaN(parseInt(value)) ? current_target.val('') : current_target.val(Number(value).toLocaleString())
});

append_success_message_in_alert_container = (success) => {
  const header_success_message = `<p class='text-success  px-4 pt-4'> <span class='fas fa-check-circle fa-lg mx-2'>\
                                </span><strong> ${success} </strong>\
                                <button class='close' data-dismiss='alert' type='button' id='close-success-alert'> \
                                <span aria-hidden='true'>×</span> \
                                <span class='sr-only'>Close</span> \
                                </button> \
                                </p>`;
  const success_message = `<div class='alert alert-success w-100'>\
                          <h6> ${header_success_message} </h6></div>`
  $('.alert-container').html(success_message);
  show_alert_container();
}

append_errors_list_in_alert_container = (errors) => {
  let error_message = `<p class='text-danger px-4 pt-4'> <span class='fas fa-times-circle fa-lg mx-2'>\
                              </span> <strong>Cannot Add due to following issues:</strong>\
                              <button class='close' type='button' id='close-errors-alert'> \
                                <span aria-hidden='true'>×</span> \
                                <span class='sr-only'>Close</span> \
                              </button> \
                            </p>`;

  for (let error of Array.from(errors)) {
    error_message += `<div class='text-danger px-5'> \
                          <ul>
                            <li> ${error.charAt(0).toUpperCase() + error.slice(1)} </li> \
                          </ul>\
                      </div>`;
  }
  $('.alert-container').removeClass('d-none')
  $('.alert-container').html(`<div class='alert alert-danger w-100'>\
                                <h6> ${error_message} </h6></div>`);
  show_alert_container();
}

window.DEFAULT_PAGE_LENGTH = 25;

$.extend(true, $.fn.dataTable.defaults, {
  lengthMenu: [10, window.DEFAULT_PAGE_LENGTH, 50, 100, 500],
  pageLength: window.DEFAULT_PAGE_LENGTH,
  language: {
    loadingRecords: '',
  },
});

$(document).on('preXhr.dt', (_event, settings, data, ajaxOptions) => {
  const wrapper = $(settings.tableWrapper);
  const header = wrapper.find('.dt-scroll-head').get(0) || settings.thead;
  const top = header.getBoundingClientRect().bottom - settings.tableWrapper.getBoundingClientRect().top;
  wrapper.find('.dt-processing').css({ top: `${top + 8}px`, marginTop: 0 });

  Object.keys(data).forEach((key) => {
    if (data[key] === undefined) delete data[key];
  });

  ajaxOptions.headers = {
    ...ajaxOptions.headers,
    Accept: 'application/json'
  };
});

window.debounce = (func, timeout = 1000) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

window.debounceSearch = (tableId) => {
  let $searchBox = $(tableId + "_wrapper .dt-search input[type='search']");
  $searchBox.off();

  let searchDebouncedFn = debounce(() => {
      $(tableId).DataTable().search($searchBox.val()).draw();
  });

  $searchBox.on("keyup search input", searchDebouncedFn);
}

window.persistedSearchState = (storageKey) => ({
  stateSave: true,
  stateSaveCallback: (settings, data) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ time: data.time, search: data.search }));
    } catch (error) {
      return;
    }
  },
  stateLoadCallback: () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey));
    } catch (error) {
      return null;
    }
  },
});

window.searchFilterBadge = (tableId) => {
  const $wrapper = $(tableId + "_wrapper");
  $wrapper.find(".search-filter-badge").remove();

  const $badge = $(
    "<div class='dt-layout-row search-filter-badge'>" +
      "<div class='alert alert-warning d-flex align-items-center justify-content-between w-100 py-2 px-3 mb-2' role='alert'>" +
        "<span><i class='fas fa-filter mr-2'></i>Search filter active — showing only rows matching <strong class='search-filter-badge-term'></strong>.</span>" +
        "<button type='button' class='btn btn-sm btn-outline-dark ml-3 text-nowrap search-filter-badge-clear'>Reset search filter</button>" +
      "</div>" +
    "</div>"
  ).hide();

  $wrapper.find(".dt-layout-table").before($badge);

  const refresh = () => {
    const term = $(tableId).DataTable().search();
    $badge.find(".search-filter-badge-term").text('"' + term + '"');
    $badge.toggle(Boolean(term));
  };

  $badge.on("click", ".search-filter-badge-clear", () => {
    $(tableId + "_wrapper .dt-search input").val("");
    $(tableId).DataTable().search("").draw();
  });

  $(tableId).off("draw.dt.searchbadge").on("draw.dt.searchbadge", refresh);
  refresh();
};

window.hide_and_clear_dropdown = (dropdown) => {
  container = dropdown.parent().closest('div')
  dropdown.val('').trigger('change')
  if (dropdown.data('multiselect')) dropdown.multiselect('refresh')
  container.addClass('d-none')
}

$(document).on('select2:open', () => {
  document.querySelector('.select2-container--open .select2-search__field').focus();
});

window.initializeSalaryOperationToggles = () => {
  $('.yes-no-toggle').bootstrapToggle({
    on: 'Yes',
    off: 'No',
    width: '100%',
    size: 'small',
    height: 'match-parent',
    style: 'rounded'
  })

  $('.allow-individual-entities-generation-toggle').bootstrapToggle({
    on: 'Entity-wise',
    off: 'Complete Salary',
    width: '100%',
    size: 'small',
    height: 'match-parent',
    style: 'rounded'
  })
}

window.close_modal = (modal) => {
  modal.removeClass('fade')
  modal.modal('toggle');
}
